// import node module libraries
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import Iframe from 'react-iframe'

// import sub components
import HeaderBreadcrumb from '../HeaderBreadcrumb';
import SEO from 'components/marketing/seo/Seo';

// import layouts
import NavbarHaeppyapp from 'layouts/marketing/navbars/NavbarHaeppyapp';
import FooterHaeppyapp from 'layouts/marketing/footers/FooterHaeppyapp';

const Statuspage = () => {
	const breadcrumb = [
		{
			page: 'Help Center',
			link: '/marketing/help-center/'
		},
		{
			page: 'Monitoring / Status',
			link: '#'
		}
	];

	return (
		<Fragment>
			<SEO
				title="Service Status & Monitoring"
				description="Wir überwachen unsere Services rund um die Uhr. Deren Status und Reaktionszeiten kannst du hier verfolgen."
				keywords="monitoring saas plattform, support multi channel e-commerce"
				canonical="https://haeppy.app/marketing/help-center/statuspage/"
			/>

			{/* header and breadcrumb */}
			<HeaderBreadcrumb title="Monitoring / Status" breadcrumb={breadcrumb} />

			{/* articles category listing cards */}
			<section className="py-10">
				<Container>
					<Row>
						<Col md={{ offset: 2, span: 8 }} xs={12}>
							<div className="mb-3">
								{/* lead  */}
								<p className="lead mb-8">
									Wir überwachen unsere Services rund um die Uhr. Deren Status und Reaktionszeiten kannst du hier verfolgen. Solltest du ein Problem festgestellt haben, so kontaktiere unseren Help Desk bitte über ein{' '}
									<Link to="/marketing/help-center/support">Service Ticket</Link>.
								</p>
								{/* Statuspage as iframe */}
								<Iframe url="https://haeppyapp.statuspage.io/"
									width="100%"
									height="1000px"
									id=""
									className="" />
							</div>
						</Col>
					</Row>
				</Container>
			</section>
		</Fragment>
	);
};

export default Statuspage;
